export default __webpack_public_path__ + "imgs/lamps.jpg";